import styles from './course.module.scss';
import Container from 'libs/react-shared-lib/src/lib/container/container';
import { Col, Row } from 'reactstrap';
import { Box } from '@frontend-workspace/react-shared-lib';
import PageTitle from '../../page-title/page-title';
import { useCourseTableHook } from '../../requestUtils';
import CourseGrid from './course-grid/course-grid';
import { ICourse } from '../../_models/course';
import CourseGridSkeleton from './course-grid/course-grid-skeleton';
import { addMonths, addYears } from 'date-fns';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CourseProps { }

export function Course(props: CourseProps) {
  const { data: courses, isLoading, getData, dateRange, onDateChange } = useCourseTableHook<ICourse>(`course/periode`, { startDate: new Date(), endDate: addMonths(new Date(), 1) });
  const { t } = useTranslation();

  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("app.courseList")} subtitle={`(${t("standard.admin")})`} />
            <CourseGrid
              courses={courses}
              refreshData={getData}
              onDateChange={onDateChange}
              dateRange={dateRange}
              isLoading={isLoading}
            />
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default Course;
